import { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { Form, Button, Modal, Alert, CloseButton } from "react-bootstrap";
import { ToastContainer, toast, Slide } from 'react-toastify';
import axios from "axios";
import md5 from "md5";
import '../../App.css';
import "../styles/MgmtRequests.css";
import 'react-toastify/dist/ReactToastify.css';

export default function MgmtUsers() {
    const [userId, setUserId] = useState('');
    const [userName, setUserName] = useState('');
    const userIdRef = useRef('');
    const userNameRef = useRef('');
    useEffect(() => {
        document.title = "Manage Users";
    
        axios.post('https://docuquest-swu.swucite.tech/api_drts/checkSession.php', {}, { withCredentials: true })
        .then((res) => {
          //console.warn("is the session alive in singleuser? ", res.data);
          if (res.data.status === 1) {
              userIdRef.current = res.data.id;
              userNameRef.current = res.data.fullname;
              setUserId(res.data.id);
              setUserName(res.data.fullname);
              
              fetchUsers();
          } 
        })
        .catch((err) => {
          //console.error("ERROR: Your session cannot be found!", err);
          notify("error", `${err}`);
        });     
    }, []);

    const notify = (type, message) => {
        const properties = {
            position: "bottom-right",
            transition: Slide,
            autoClose: 1900,
            draggable: true,
            closeOnClick: true,
            pauseOnHover: false,
        }

        if (toast[type]) {
            toast[type](message, properties); // e.g., toast.success("Success message")
        } else {
            toast(message, properties); // Default toast if type is unknown
        }

        // TODO custom css class
    }

    const formatToSQLDateTime = (isoDateTime) => {
        const date = new Date(isoDateTime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit format
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = "00"; // Manually set seconds to match SQL format
    
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const [dataRoles, setRoles] = useState([]);
    const [users_data, setUsers] = useState([
        {
            id: '',
            pfp: '',
            name: '',
            email: '',
            typeAccount: '',
            status: '',
            jobTitle: '',
            createdAt: '',
            updatedAt: '',
            user_courses: [],
        }
    ]);
    const [showModal, setShowModal] = useState(false); // State to show/hide the modal
    const [newUserData, setNewUserData] = useState({
        staffFirstName: '',
        staffMiddleName: '',
        staffLastName: '',
        staffEmail: '',
        staffPhone: '',
        staffPass: '',
        staffRole: '',
        createdAt: '',
        updatedAt: '',
        user_courses: [],
    });

    const [errorTable, setErrorTable] = useState({
        type: "",
        message: ""
    });

    const [errorModal, setErrorModal] = useState({
        type: "",
        message: ""
    });


    // TODO custom confirmation popup (refer to singlerequest.js)
    const doDeactivate = (e, userId, userName) => {
        e.stopPropagation();

        const confirmed = window.confirm(`Are you sure you want to deactivate ${userName}?`)
        if (confirmed) {
          handleDeactivate(userId)
        }
    }

    const doActivate = (e, userId, userName) => {
        e.stopPropagation();
        
        const confirmed = window.confirm(`Are you sure you want to reactivate ${userName}?`)
        if (confirmed) {
          handleActivate(userId)
        }
    }

    const [showEditModal, setShowEditModal] = useState(false);
    const [editingUser, setEditingUser] = useState(null);
    const [editSelectedCourses, setEditSelectedCourses] = useState([]);

  const handleEditUser = async (user) => {
    try {
      // Fetch all available courses
      const response = await axios.get('https://docuquest-swu.swucite.tech/api_drts/courses.php');
      const allCourses = response.data.status === 'success' ? response.data.courses : [];
      
      // Debug: Log the user's current courses
      //console.log('User courses data:', user.user_courses);
      
      // Convert user's courses to an array of numeric IDs
      const userCourseIds = [];
      if (user.user_courses && user.user_courses.length > 0) {
        user.user_courses.forEach(course => {
          if (typeof course === 'object' && course.id) {
            userCourseIds.push(Number(course.id));
          } else if (!isNaN(Number(course))) {
            userCourseIds.push(Number(course));
          }
        });
      }
      
      // Debug: Log the converted IDs
      //console.log('Converted course IDs:', userCourseIds);
      
      setEditSelectedCourses(userCourseIds);
      setEditingUser(user);
      setCourses(allCourses);
      setShowEditModal(true);
      
    } catch (error) {
      //console.error('Error in handleEditUser:', error);
      notify("error", `Error preparing to edit user: ${error}`);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    
    if (!editingUser) return;

    try {
        const numericCourses = editSelectedCourses.map(id => Number(id));
        const response = await axios.put(
        `https://docuquest-swu.swucite.tech/api_drts/users.php/${editingUser.id}`,
        { courses: numericCourses }
        );

        if (response.data.status === 1) {
        notify("success", `Successfully updated ${editingUser.name}'s courses`);
        
        // Update the specific user in state
        setUsers(prevUsers => prevUsers.map(user => 
            user.id === editingUser.id 
            ? { ...user, user_courses: numericCourses } 
            : user
        ));
        
        setShowEditModal(false);

        const today = new Date();

                    axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                        updated_by: userIdRef.current,
                        updated_date: formatToSQLDateTime(today),
                        created_by: userIdRef.current,
                        created_date: formatToSQLDateTime(today),
                        feedback: `Courses of ${editingUser.name} edited`,
                        name_action: "User Courses Edited" ,
                        status_action: `Courses edited by ${userNameRef.current}`,
                        stage_now: 1,
                        stage_max: 1,
                        score_eff: 0.5,
                        score_prod: 0.7
                    })
                    .then(() => {
                                    
                    })
                    .catch((err) => {

                    })          
        } else {
        notify("error", `Failed to update courses: ${response.data.message}`);
        }
    } catch (error) {
        notify("error", `Error updating courses: ${error.response?.data?.message || error.message}`);
    }


        // Ensure all course IDs are numbers
        const numericCourses = editSelectedCourses.map(id => Number(id));
        
        try {
            const response = await axios.put(
                `https://docuquest-swu.swucite.tech/api_drts/users.php/${editingUser.id}`,
                { courses: numericCourses }
            );

            if (response.data.status === 1) {
                notify("success", `Successfully updated ${editingUser.name}'s courses`);
                await fetchUsers();
                setShowEditModal(false);
            } else {
                notify("error", `Failed to update courses: ${response.data.message}`);
            }
        } catch (error) {
            notify("error", `Error updating courses: ${error.response?.data?.message || error.message}`);
        }
    };

    const handleEditCourseSelection = (courseId) => {
        // Ensure courseId is a number
        const numericCourseId = Number(courseId);
        
        setEditSelectedCourses(prev => {
          // Create a new array to avoid state mutation
          const newSelection = [...prev];
          const index = newSelection.indexOf(numericCourseId);
          
          if (index > -1) {
            // Remove if already exists
            newSelection.splice(index, 1);
          } else {
            // Add if not exists
            newSelection.push(numericCourseId);
          }
          
          return newSelection;
        });
    };

    const [fetchCourses, setFetchCourses] = useState(false);
    const [courses, setCourses] = useState([]); // Initialize as an empty array
    const [selectedCourses, setSelectedCourses] = useState([]);

    const handleCourseSelection = (courseId) => {
        setSelectedCourses((prevSelected) => {
          if (prevSelected.includes(courseId)) {
            // If the course is already selected, remove it
            return prevSelected.filter((id) => id !== courseId);
          } else {
            // If the course is not selected, add it
            return [...prevSelected, courseId];
          }
        });
      };

    const handleFetchCourses = async (isChecked) => {
        setFetchCourses(isChecked);
        if (isChecked) {
          try {
            const response = await axios.get('https://docuquest-swu.swucite.tech/api_drts/courses.php');
            //console.log("API Response:", response.data); // Log the full response
      
            // Check if the response contains the 'courses' array
            if (response.data.status === 'success' && Array.isArray(response.data.courses)) {
              setCourses(response.data.courses); // Set the courses array
            } else {
              //console.error("Expected an array but got:", response.data);
              setCourses([]); // Set to empty array if the response is invalid
              notify("error", "Invalid data format received from the server.");
            }
          } catch (error) {
            notify("error", `Error fetching courses: ${error}`);
            setErrorModal({
              type: "danger",
              message: `Error fetching courses: ${error}`,
            });
            setCourses([]); // Set to empty array on error
          }
        } else {
          setCourses([]); // Clear courses when unchecked
        }
      };

    // Fetch users from the API
    const fetchUsers = async () => {
        try {
            const loggedInUserId = userIdRef.current;

            const response = await axios.get('https://docuquest-swu.swucite.tech/api_drts/users.php');
            const users = response.data
            .filter(user => user.id !== parseInt(loggedInUserId, 10)) // Do not display the currently logged-in user in the table
            .map(user => ({
                id: user.id,
                pfp: user.pfp,
                name: `${user.lastname}, ${user.firstname}${user.middlename ? " " + user.middlename[0] + "." : ""}`,
                email: user.email,
                typeAccount: user.account_type,
                status: user.status,
                jobTitle: user.job_title,
                createdAt: user.created_at,
                updatedAt: user.updated_at,
                user_courses: user.user_courses || [],
            }));

            //console.log("got users:", users);
            setUsers(users);
            setFilteredUsers(users);
        } catch (err) {
            notify("error", `ERROR getting users: ${err}`);
            setErrorTable({
                type:"danger",
                message:`ERROR getting users: ${err}`
            })
        }
    };

    useEffect(() => {
        fetchUsers();
        axios
            .get("https://docuquest-swu.swucite.tech/api_drts/userRoles.php")
            .then((response) => {
                setRoles(response.data)
            })
            .catch((err) => {
              notify("error", `ERROR getting user roles: ${err}`);
              setErrorModal({ type:"danger", message:`ERROR getting user roles: ${err}`})
            }) 
    }, []);    
    
    const handleActivate = async (userId) => {
        if (!userId) {
            notify("error", `Failed to reactivate user: Invalid or missing ID "${userId}"`);
            setErrorTable({
                type:"danger",
                message:`Failed to reactivate user: Invalid or missing ID "${userId}"`
            })
            return;
        }

        try {
            const response = await axios.patch(`https://docuquest-swu.swucite.tech/api_drts/userActive.php?id=${userId}`);
            // console.log("Response from backend:", response); // Log the full response
            if (response.data.status === 1) {
                notify("success", `Reactivated: ${response.data.message}`);
                setErrorTable({
                    type:"success",
                    message:`Reactivated: ${response.data.message}`
                })

                const today = new Date();

                    axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                        updated_by: userIdRef.current,
                        updated_date: formatToSQLDateTime(today),
                        created_by: userIdRef.current,
                        created_date: formatToSQLDateTime(today),
                        feedback: `Activated user: ${userId}`,
                        name_action: "User Activated" ,
                        status_action: `Activated by ${userNameRef.current}`,
                        stage_now: 1,
                        stage_max: 1,
                        score_eff: 0.5,
                        score_prod: 0.7
                    })
                    .then(() => {
                                    
                    })
                    .catch((err) => {

                    })                  

                await fetchUsers();
            } else {
                notify("error", `Failed to reactivate user: ${response.data.message}`);
                setErrorTable({
                    type:"warning",
                    message:`Failed to reactivate user: ${response.data.message}`
                })
            }
        } catch (error) {
            notify("error", `Error reactivating user: ${error}`);
            setErrorTable({
                type:"danger",
                message:`Error reactivating user: ${error}`
            })
        }
    }

    const handleDeactivate = async (userId) => {
        if (!userId) {
            notify("error", `Failed to deactivate user: Invalid or missing ID "${userId}"`);
            setErrorTable({
                type:"danger",
                message:`Failed to deactivate user: Invalid or missing ID "${userId}"`
            })
            return;
        }

        try {
            const response = await axios.delete(`https://docuquest-swu.swucite.tech/api_drts/users.php?id=${userId}`);
            //console.log("Response from backend:", response); // Log the full response
            if (response.data.status === 1) {
                notify("success", `Deactivated: ${response.data.message}`);
                setErrorTable({
                    type:"warning",
                    message:`Deactivated: ${response.data.message}`
                })
                    const today = new Date();

                    axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                        updated_by: userIdRef.current,
                        updated_date: formatToSQLDateTime(today),
                        created_by: userIdRef.current,
                        created_date: formatToSQLDateTime(today),
                        feedback: `Deactivated user ${userId}`,
                        name_action: "User Deactivated" ,
                        status_action: `Deactivated by ${userNameRef.current}`,
                        stage_now: 1,
                        stage_max: 1,
                        score_eff: 0.5,
                        score_prod: 0.4
                    })
                    .then(() => {
                                    
                    })
                    .catch((err) => {

                    })                  
                await fetchUsers();
            } else {
                notify("error", `Failed to deactivate user:  ${response.data.message}`);
                setErrorTable({
                    type:"danger",
                    message:`Failed to deactivate user:  ${response.data.message}`
                })
            }
        } catch (error) {
            setErrorTable({
                type:"danger",
                message:`Error reactivating user: ${error}`
            })
        }
    };

    const [errors, setErrors] = useState({});
    const [showAlert, setShowAlert] = useState(false);

    // Modal handling functions
    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setErrors({});
        setShowAlert(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewUserData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };
    
    const validateFields = () => {
        const newErrors = {};
        if (!newUserData.staffFirstName) newErrors.staffFirstName = 'First name is required';
        if (!newUserData.staffLastName) newErrors.staffLastName = 'Last name is required';
        if (!newUserData.staffEmail) newErrors.staffEmail = 'Email is required';
        if (!newUserData.staffPhone) newErrors.staffPhone = 'Phone is required';
        if (!newUserData.staffRole) newErrors.staffRole = 'Role is required';
        if (!newUserData.confirmPass1 || !newUserData.confirmPass2) {
            newErrors.confirmPass = 'Both password fields are required';
        } else if (newUserData.confirmPass1 !== newUserData.confirmPass2) {
            newErrors.confirmPass = 'Passwords do not match';
        }

        setErrors(newErrors);
        setShowAlert(Object.keys(newErrors).length > 0); // Show alert if there are errors
        return Object.keys(newErrors).length === 0; // Return true if no errors
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
      
        if (!validateFields()) {
          return; // Don't proceed if validation fails
        }
      
        try {
          const payload = {
            ...newUserData,
            staffPass: newUserData.confirmPass2,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
            courses: selectedCourses, // Include selected courses
          };
      
          const response = await axios.post('https://docuquest-swu.swucite.tech/api_drts/users.php', payload);
      
          if (response.data.status === 1) {
            await fetchUsers();
            handleCloseModal();
            setErrors({});
            setShowAlert(false);
            setSelectedCourses([]); // Clear selected courses after submission

            const today = new Date();

                    axios.post(`https://docuquest-swu.swucite.tech/api_drts/workflow.php`, {
                        updated_by: userIdRef.current,
                        updated_date: formatToSQLDateTime(today),
                        created_by: userIdRef.current,
                        created_date: formatToSQLDateTime(today),
                        feedback: `New user: ${newUserData.staffLastName}, ${newUserData.staffFirstName}, ${newUserData.staffMiddleName}`,
                        name_action: "New User Added" ,
                        status_action: `New user added by ${userNameRef.current}`,
                        stage_now: 1,
                        stage_max: 1,
                        score_eff: 1.0,
                        score_prod: 0.8
                    })
                    .then(() => {
                                    
                    })
                    .catch((err) => {

                    })              
          } else {
            notify("error", `Failed to create user: ${response.data.message}`);
            setErrorModal({
              type: "danger",
              message: `Failed to create user: ${response.data.message}`,
            });
          }
        } catch (error) {
          setErrorModal({
            type: "danger",
            message: `Error creating user: ${error}`,
          });
        }
      };


    // users searchbar
    const [searchValue, setSearchValue] = useState('');
    const [searchSuggestions, setSearchSuggestions] = useState([]); // TODO search sugggestions
    
    const [filteredUsers, setFilteredUsers] = useState([]);

const handleSearchChange = (e) => {
    const searchQuery = e.target.value.toLowerCase();
    setSearchValue(searchQuery);

    const filteredBySearch = users_data.filter((user) =>
        (user.name?.toLowerCase() || '').includes(searchQuery) ||
        (user.email?.toLowerCase() || '').includes(searchQuery) ||
        (user.createdAt?.toLowerCase() || '').includes(searchQuery) ||
        (user.updatedAt?.toLowerCase() || '').includes(searchQuery) ||
        (user.typeAccount?.toLowerCase() || '').includes(searchQuery) || 
        (user.status?.toLowerCase() || '').includes(searchQuery)
    );
    setFilteredUsers(filteredBySearch);
    setPageNow(1);
};

    
    // format timestamps into "Month Day, Year" format
    const formatDate = (timestamp) => {
        const date = new Date(timestamp); 
        return date.toLocaleDateString('en-US', {
            month: 'short', 
            day: 'numeric', 
            year: 'numeric' 
        });
    };

    // switch case for payment status css class
    const getStatusWage = (statusWage) => {
        let colorWage = '';
        
        switch (statusWage) {
            case 'Paid':
                colorWage = 'payment-status paid';
                break;
                
            case 'Not Paid':
                colorWage = 'payment-status not-paid';
                break;
                    
            default:
                break;
        }
                    
        return colorWage;
    }
                
    // switch case for job status css class
    const getStatusJob = (statusJob) => {
        let colorJob = '';
                    
        switch (statusJob) {
            case 'On Duty':
                colorJob = 'status in-progress'
                break;
                
            case 'Off Duty':
                colorJob = 'status queue'
                break;
        
            case 'On Leave':
                colorJob = 'status in-review'
                break;
                
            default:
                break;
        }
                
        return colorJob;
    }
    
    // pagination
    const [pageNow, setPageNow] = useState(1);
    const rowsNow = 15; // TODO user can adjust how many rows to see
    var indxLast = pageNow * rowsNow;
    var indxFirst = indxLast - rowsNow;
    
    const paginatedUsers = filteredUsers.slice(indxFirst, indxLast);
    var pageTotal = Math.ceil(filteredUsers.length / rowsNow);
    var pageNumbers = [...Array(pageTotal + 1).keys()].slice(1);
    
    const pagePrev = () => {
        if (pageNow > 1) {
            setPageNow(pageNow - 1)
        }
    }

    const pageNext = () => {
        if (pageNow < pageTotal) {
            setPageNow(pageNow + 1)
        }
    }

    const changePage = (id) => {
        setPageNow(id)
    }
    
    const navigate = useNavigate();
    
    const handleNavigation = (path) => {
        navigate(path);
    };
    
    return (
        <div className="mgmt-users">
            <header className="header">
                <h1>User Management</h1>
            </header>

            <article className='dash-group'>
                <div className='dash-row'>
                    <button onClick={handleShowModal} className="create-user-btn">
                        Create User
                    </button>
                </div>

                <input
                type="text"
                placeholder="Search"
                value={searchValue}
                onChange={handleSearchChange}
                className="search-input group"
                />
            </article>

            {errorTable ? (
                <Alert variant={errorTable.type}>
                    {errorTable.message}
                </Alert>
            ) : ""
            }
            <table className="documents-table">
                <thead>
                    {
                        paginatedUsers.length > 0 && (
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th>Courses</th>
                            <th>Actions</th>
                        </tr>
                        )
                    }
                </thead>
                <tbody>
                    {paginatedUsers.length > 0 ? (
                        paginatedUsers.map((user, index) => (
                            <tr key={user.id} onClick={()=>{navigate(`/manage/${user.id}`)}}>
                                <td>{user.name}</td>
                                <td>{user.email}</td>
                                <td>{user.typeAccount}</td>
                                <td>
                                {user.user_courses && user.user_courses.length > 0
                                    ? user.user_courses.join(", ") // Display courses as a comma-separated string
                                    : <span className="text-muted">No courses assigned</span>} {/* Fallback if no courses are assigned */}
                                </td>    
                                <td>
                                    <div className="actions-wrapper">
                                    <button
                                        onClick={(e) => {
                                        e.stopPropagation();
                                        handleEditUser(user);
                                        }}
                                        className="edit-btn"
                                        title={`Edit ${user.name}'s courses`}
                                    >
                                        Edit&nbsp;Courses
                                    </button>        
                                    
                                    {user.status === 'active' ? (
                                        <button
                                        onClick={(e) => doDeactivate(e, user.id, user.name)}
                                        className="deactivate-btn"
                                        title={`Deactivate ${user.name}`}
                                        >
                                        Deactivate
                                        </button>
                                    ) : (
                                        <button
                                        onClick={(e) => doActivate(e, user.id, user.name)}
                                        className="activate-btn"
                                        title={`Activate ${user.name}`}
                                        >
                                        Activate
                                        </button>
                                    )}
                                    </div>
                                </td>
                            </tr>
                            ))
                    ) : (
                        <tr>
                            <td colSpan="6" className="no-results">
                                No results for user "{searchValue}"
                            </td>
                        </tr>
                    )
                    }
                </tbody>
            </table>

            {/* Modal for creating user */}
            {showModal && (
                <Modal centered show={showModal} onHide={handleCloseModal} dialogClassName="modal-custom" backdrop={false} animation={false}>
                    <article className="modal-close">
                        <CloseButton onClick={() => setShowModal(false)} className="custom-close-btn" title="Close create user modal"/>
                    </article>

                    <Modal.Header>
                      <div className='title-wrapper'>
                        <h3>Create&nbsp;User</h3>                        
                        <p><span className="required" >*</span> — required fields</p>
                      </div>
                    </Modal.Header>
                    <Modal.Body className="modal-custom-content">
                        {errorModal ? (
                            <Alert variant={errorModal.type}>
                                {errorModal.message}
                            </Alert>
                        ) : ""
                        }
                        {showAlert && (
                            <Alert variant="danger" onClose={() => setShowAlert(false)} dismissible>
                                <ul>
                                    {Object.values(errors).map((error, index) => (
                                        <li key={index}>{error}</li>
                                    ))}
                                </ul>
                            </Alert>
                        )}
                        <form onSubmit={handleSubmit} className='form-crud'>
                            <div className="label-wrapper">
                              <label for='staffFirstName'><span className="required" >*</span>&nbsp;First&nbsp;name</label>
                              <input
                                required
                                placeholder="Enter first name"
                                type="text"
                                name="staffFirstName"
                                value={newUserData.staffFirstName}
                                onChange={handleChange}
                                isInvalid={!!errors.staffFirstName}
                              />
                            </div>
                            
                            <div className="label-wrapper">
                              <label for='staffMiddleName'>Middle&nbsp;name</label>
                              <p className='subtxt'>(Leave&nbsp;blank&nbsp;if&nbsp;no&nbsp;middle&nbsp;name)</p>
                              <input
                                placeholder="Enter middle name"
                                type="text"
                                name="staffMiddleName"
                                value={newUserData.staffMiddleName}
                                onChange={handleChange}
                              />
                            </div>

                            <div className="label-wrapper">
                              <label for='staffLastName'><span className="required" >*</span>&nbsp;Last&nbsp;name</label>
                              <input
                                required
                                placeholder="Enter last name"
                                type="text"
                                name="staffLastName"
                                value={newUserData.staffLastName}
                                onChange={handleChange}
                                isInvalid={!!errors.staffLastName}
                              />
                            </div>
                            {errors.staffFirstName || errors.staffLastName}
                            
                            <div className="label-wrapper">
                            <label for='staffEmail'><span className="required" >*</span>&nbsp;Email</label>
                            </div>
                            <input
                                required
                                placeholder="Enter email"
                                type="email"
                                name="staffEmail"
                                value={newUserData.staffEmail}
                                onChange={handleChange}
                                isInvalid={!!errors.staffEmail}
                            />
                            {errors.staffEmail}
                            <div className="label-wrapper">
                            <label for='staffPhone'><span className="required" >*</span>&nbsp;Phone</label>
                            </div>
                            <input
                                required
                                placeholder="Enter phone number"
                                type="number"
                                name="staffPhone"
                                class="no-spinner"
                                value={newUserData.staffPhone}
                                onChange={handleChange}
                                isInvalid={!!errors.staffPhone}
                            />
                            {errors.staffPhone}
                            <div className="label-wrapper">
                            <label for='confirmPass1'><span className="required" >*</span>&nbsp;Password</label>
                            </div>
                            <input
                                required
                                placeholder="Enter password"
                                type="password"
                                name="confirmPass1"
                                value={newUserData.confirmPass1}
                                onChange={handleChange}
                                className={`form-control ${errors.confirmPass1 ? 'is-invalid' : ''}`}
                            />
                            {errors.confirmPass1 && <div className="invalid-feedback">{errors.confirmPass1}</div>}
                            <div className="label-wrapper">
                            <label for='confirmPass2'><span className="required" >*</span>&nbsp;Confirm password</label>
                            </div>
                            <input
                                required
                                placeholder="Confirm your password"
                                type="password"
                                name="confirmPass2"
                                value={newUserData.confirmPass2}
                                onChange={handleChange}
                                className={`form-control ${errors.confirmPass2 ? 'is-invalid' : ''}`}
                            />
                            {errors.confirmPass2 && <div className="invalid-feedback">{errors.confirmPass2}</div>}
                            <div className="label-wrapper">
                            <label for='staffRole'><span className="required" >*</span>&nbsp;Role</label>
                            </div>
                            <select
                                required 
                                name="staffRole"
                                value={newUserData.staffRole} 
                                onChange={handleChange}
                                isInvalid={!!errors.staffRole}
                            >
                                <option value="">Select Role</option>
                                {dataRoles.map((role)=>(
                                <option key={role.id} value={role.name_role}>
                                {role.name_role}    
                                </option>
                                ))}
                            </select>
                            {errors.staffRole}    
                            <div className="label-wrapper">
                              <label>
                                <input
                                  type="checkbox"
                                  name="fetchCourses"
                                  onChange={(e) => handleFetchCourses(e.target.checked)}
                                />
                                Fetch Courses
                              </label>
                            </div>
                            {fetchCourses && (
                            <div className="label-wrapper">
                                <label>Courses</label>
                                {Array.isArray(courses) && courses.length > 0 ? (
                                <ul>
                                    {courses.map((course) => (
                                    <li key={course.id}>
                                        <label>
                                        <input
                                            type="checkbox"
                                            checked={selectedCourses.includes(course.id)} // Check if the course is selected
                                            onChange={() => handleCourseSelection(course.id)} // Handle checkbox change
                                        />
                                        {course.course_name}
                                        </label>
                                    </li>
                                    ))}
                                </ul>
                                ) : (
                                <p>No courses available.</p>
                                )}
                            </div>
                            )}
                            <div style={{ display: "flex", justifyContent: "space-around", marginTop: "1rem" }}>
                                <button 
                                    onClick={() => setShowModal(false)} 
                                    title="Close create user modal" 
                                    style={{ 
                                    background: "red", 
                                    border: "1px solid #ccc", 
                                    padding: "0.5rem 1rem", 
                                    cursor: "pointer",
                                    transition: "background-color 0.3s, color 0.3s",
                                    }}
                                    onMouseOver={(e) => {
                                    e.target.style.backgroundColor = "red"; // Light red for hover
                                    e.target.style.color = "#721c24"; // Dark red for text
                                    }}
                                    onMouseOut={(e) => {
                                    e.target.style.backgroundColor = "transparent";
                                    e.target.style.color = "black";
                                    }}
                                >
                                    Cancel
                                </button>
                                <button 
                                    type="submit" 
                                    style={{ 
                                    background: "#007BFF", 
                                    border: "none", 
                                    color: "#fff", 
                                    padding: "0.5rem 1rem", 
                                    cursor: "pointer",
                                    transition: "background-color 0.3s, box-shadow 0.3s",
                                    }}
                                    onMouseOver={(e) => {
                                    e.target.style.backgroundColor = "#0056b3"; // Darker blue for hover
                                    e.target.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)"; // Add shadow
                                    }}
                                    onMouseOut={(e) => {
                                    e.target.style.backgroundColor = "#007BFF";
                                    e.target.style.boxShadow = "none";
                                    }}
                                >
                                    Create
                                </button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            )}        

            {showEditModal && editingUser && (
                <Modal centered show={showEditModal} onHide={() => setShowEditModal(false)}>
                    <Modal.Header closeButton>
                    <Modal.Title>Edit Courses for {editingUser.name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <form onSubmit={handleEditSubmit}>
                        <div className="mb-3">
                        <label className="fw-bold">Available Courses</label>
                        {courses.length > 0 ? (
                            <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #dee2e6', padding: '10px' }}>
                            {courses.map((course) => {
                                const courseId = Number(course.id); // Ensure numeric ID
                                const isChecked = editSelectedCourses.includes(courseId);
                                
                                return (
                                <div key={course.id} className="form-check mb-2">
                                    <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`course-${course.id}`}
                                    checked={isChecked}
                                    onChange={() => handleEditCourseSelection(courseId)}
                                    />
                                    <label 
                                    htmlFor={`course-${course.id}`} 
                                    className="form-check-label d-flex align-items-center"
                                    >
                                    <span>{course.course_name}</span>
                                    {isChecked && (
                                        <span className="badge bg-success ms-2">Assigned</span>
                                    )}
                                    </label>
                                </div>
                                );
                            })}
                            </div>
                        ) : (
                            <div className="alert alert-info">No courses available</div>
                        )}
                        </div>
                        <div className="d-flex justify-content-end gap-2 mt-3">
                        <button 
                            type="button" 
                            className="btn btn-outline-secondary"
                            onClick={() => setShowEditModal(false)}
                        >
                            Cancel
                        </button>
                        <button 
                            type="submit" 
                            className="btn btn-primary"
                            disabled={editSelectedCourses.length === 0}
                        >
                            Save Changes
                        </button>
                        </div>
                    </form>
                    </Modal.Body>
                </Modal>
            )}

            {/* Pagination */}
            {paginatedUsers.length > 0 && (
                <div className="pagination">
                    <button onClick={() => changePage(1)} disabled={pageNow === 1}>&lt;&lt;</button> 
                    <button onClick={pagePrev} disabled={pageNow === 1}>&lt; Previous</button>
    
                    {
                    pageNumbers.map((number, index) => (
                      <button key={index} onClick={() => changePage(number)} className={pageNow === number ? 'active' : ''}>
                        {number}
                      </button>  
                    ))
                    }
                    
                    <button onClick={pageNext} disabled={pageNow === pageTotal}>Next &gt;</button>
                    <button onClick={() => changePage(pageTotal)} disabled={pageNow === pageTotal}>&gt;&gt;</button>
                </div>                    
                )     
            }

            <ToastContainer newestOnTop/>
        </div>
    )
}
